import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkString'
})
export class CheckStringPipe implements PipeTransform {

  transform(value: any): any {
    let stylizedText: string = '';
    let supportedRegex = '(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})';
    let newSupRegex = new RegExp(supportedRegex);
    let validFileType = newSupRegex.test(value);

    if(validFileType){
      stylizedText += `<a class="hyperLink">${value}</a> `;
    } else {
      stylizedText = value;
    }

    // console.log('------------------ in pipe validFileType-----------------');
    // console.log(stylizedText);

    return stylizedText;
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/check-string.pipe.ts